import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SharedService } from './shared.service';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HandleHttpError } from './error.handler';
import { ApplicationPayment, Voucher, PaymentUpdateModel, CohortPaymentParameter } from '../../application/models/application-payment';


@Injectable()
export class PaymentService {

  baseURL: string;

  constructor(private http: HttpClient, private sharedService: SharedService) {
    this.baseURL = this.sharedService.getBaseURL();
  }


  getpaymentgatewayurl(paymentApplicationTypeId: number, applicationId: number, totalAmountAfterDiscount: number, invoiceNumber: string): Observable<any>  {
    var internalApiUrl = this.baseURL + `/payment/getexternalpaymentserviceurl?paymentApplicationTypeId=${paymentApplicationTypeId}&onelineApplicationId=${applicationId}&paymentAmount=${totalAmountAfterDiscount}&invoiceNumber=${invoiceNumber}`;

    //console.log("internal api URL is: " + internalApiUrl);

    //alert(internalApiUrl);
    return this.http.get(internalApiUrl).pipe(catchError(err => HandleHttpError(err)))
  }


  //Cohort Url base part 
  getcohortpaymentgatewayurl() {
    var internalApiUrl = this.baseURL + `/payment/getcohortpaymentserviceurl`;
    return this.http.get(internalApiUrl).pipe(catchError(err => HandleHttpError(err)))
  }

  //Cohort POST data part 
  getcohortpaymentparameterbase(applicationId: number) {
    var internalApiUrl = this.baseURL + `/payment/getcohortpaymentparameterbase?applicationId=` + applicationId;
    return this.http.get(internalApiUrl).pipe(catchError(err => HandleHttpError(err)))
  }


  updatepaymentrecord(paymentUpdateModel: PaymentUpdateModel ): Observable<any> {

    var internalApiUrl = this.baseURL + `/applications/${paymentUpdateModel.ApplicationId}/updatepayment`;
    //console.log("internal api URL is: " + internalApiUrl);
    //alert(internalApiUrl);
    return this.http.post(internalApiUrl, paymentUpdateModel)
      .pipe(catchError(err => HandleHttpError(err)));

  }

}
